import jsPDF from 'jspdf';
import 'jspdf-autotable';

const LOGO_BASE64 = 'data:image/jpeg;base64,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';

// ---------------------------------------------------------------------------
// Shared helper: safely parse a customer address (JSON or plain string).
// Returns a formatted string like "Street Name\nCity - 627001",
// or null if no meaningful address data is present.
// ---------------------------------------------------------------------------
function parseAddress(raw) {
  if (!raw) return null;
  try {
    const p = JSON.parse(raw);
    const street = (p.street || '').trim();
    const city   = (p.city   || '').trim();
    const pin    = (p.pincode || '').trim();
    const lines  = [];
    if (street) lines.push(street);
    const cityLine = city ? (pin ? `${city} - ${pin}` : city) : pin;
    if (cityLine) lines.push(cityLine);
    return lines.length > 0 ? lines.join('\n') : null;
  } catch (e) {
    const plain = String(raw).trim();
    return plain.length > 0 ? plain : null;
  }
}

export function generateBillPDF(bill) {
  const doc = new jsPDF();
  const pageW = doc.internal.pageSize.getWidth();

  // Header background
  doc.setFillColor(64, 23, 4);
  doc.rect(0, 0, pageW, 45, 'F');

  // Add logo image
  doc.addImage(LOGO_BASE64, 'JPEG', 14, 10, 24, 24);

  // Store name (shifted right)
  doc.setFont('times', 'bold');
  doc.setFontSize(22);
  doc.setTextColor(201, 168, 76);
  doc.text('New Sowtha', 42, 20);

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.setTextColor(180, 180, 180);
  doc.text('Smart Billing Software', 42, 27);
  doc.text('Tel: +91 9361713753  |  +91 7639042406', 42, 33);
  doc.text('newsowthaoffice@gmail.com  |  www.newsowtha.com', 42, 39);

  // Invoice label
  doc.setFont('times', 'bold');
  doc.setFontSize(14);
  doc.setTextColor(255, 255, 255);
  doc.text('TAX INVOICE', pageW - 14, 20, { align: 'right' });
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.setTextColor(200, 200, 200);
  doc.text(`Invoice No: ${bill.invoiceNo}`, pageW - 14, 28, { align: 'right' });
  doc.text(`Date: ${new Date(bill.createdAt).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}`, pageW - 14, 35, { align: 'right' });
  doc.text(`Billed by: ${bill.employee?.name || 'Staff'}`, pageW - 14, 41, { align: 'right' });

  // Customer section
  doc.setFillColor(248, 249, 250);
  doc.rect(0, 48, pageW, 30, 'F');

  // Col 1: BILL TO
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(8);
  doc.setTextColor(100, 100, 100);
  doc.text('BILL TO', 14, 57);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.setTextColor(30, 30, 30);
  doc.text((bill.customer?.name || 'Customer').toUpperCase(), 14, 65);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.setTextColor(80, 80, 80);
  if (bill.customer?.phone) doc.text(`Phone: ${bill.customer.phone}`, 14, 72);

  // Col 2: ADDRESS
  const billAddressText = parseAddress(bill.customer?.address);
  if (billAddressText) {
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);
    doc.text('ADDRESS', 90, 57);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.setTextColor(80, 80, 80);
    const wrappedAddress = doc.splitTextToSize(billAddressText, 60);
    doc.text(wrappedAddress, 90, 65);
  }

  // Col 3: PAYMENT MODE
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(8);
  doc.setTextColor(100, 100, 100);
  doc.text('PAYMENT MODE', pageW - 14, 57, { align: 'right' });
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.setTextColor(30, 30, 30);
  doc.text((bill.paymentMode || 'Cash').toUpperCase(), pageW - 14, 65, { align: 'right' });

  // Items table
  const tableRows = [];
  let rowIdx = 1;
  
  (bill.items || []).forEach((item) => {
    const rateVal = item.unitRate || item.price || 0;
    const nameVal = (item.productName || '').toUpperCase();
    const returnQty = item.returnQty || item.return_qty || 0;
    
    // 1. Sale row
    tableRows.push([
      rowIdx++,
      nameVal,
      item.quantity,
      `Rs. ${rateVal.toFixed(2)}`,
      `Rs. ${(item.quantity * rateVal).toFixed(2)}`
    ]);
    
    // 2. Return row if returnQty > 0
    if (returnQty > 0) {
      tableRows.push([
        rowIdx++,
        `[RETURN] ${nameVal}`,
        returnQty,
        `-Rs. ${rateVal.toFixed(2)}`,
        `-Rs. ${(returnQty * rateVal).toFixed(2)}`
      ]);
    }
  });

  doc.autoTable({
    startY: 85,
    head: [['#', 'PRODUCT', 'QTY', 'UNIT PRICE', 'TOTAL']],
    body: tableRows,
    theme: 'grid',
    headStyles: { fillColor: [64, 23, 4], textColor: 255, fontSize: 9, fontStyle: 'bold', cellPadding: 4, valign: 'middle' },
    bodyStyles: { fontSize: 9, cellPadding: 4, textColor: [50, 50, 50], valign: 'middle' },
    alternateRowStyles: { fillColor: [250, 250, 248] },
    columnStyles: {
      0: { halign: 'center', cellWidth: 16 },
      1: { cellWidth: 'auto' },
      2: { halign: 'center', cellWidth: 20 },
      3: { halign: 'right', cellWidth: 32 },
      4: { halign: 'right', cellWidth: 35 }
    },
    margin: { left: 14, right: 14 }
  });

  let currentY = doc.lastAutoTable.finalY + 6;
  const pageHeight = doc.internal.pageSize.getHeight();

  // If totals block or bank details might overflow the footer area, add a page
  if (currentY + 45 > pageHeight - 20) {
    doc.addPage();
    currentY = 20;
  }

  // Draw Bank Details Box on the left (x = 14, width = 100)
  const bankX = 14;
  const bankWidth = 100;
  const bankHeight = 42;

  doc.setFillColor(248, 249, 250);
  doc.setDrawColor(201, 168, 76);
  doc.setLineWidth(0.5);
  doc.rect(bankX, currentY, bankWidth, bankHeight, 'FD');

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.setTextColor(64, 23, 4);
  doc.text('BANK DETAILS', bankX + 5, currentY + 6);

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(8);
  doc.setTextColor(50, 50, 50);
  doc.text('Acc Name: NEW SOWTHA LIGHTS HARDWARES AND TOOLS', bankX + 5, currentY + 12);
  doc.text('Bank Name: CITY UNION BANK', bankX + 5, currentY + 18);
  doc.text('Branch: TENKASI', bankX + 5, currentY + 24);
  doc.text('Acc No: 512020010031635', bankX + 5, currentY + 30);
  doc.text('IFSC Code: CIUB0000376', bankX + 5, currentY + 36);

  // Totals on the right
  const totalsX = pageW - 14;
  let totalsY = currentY + 5;

  doc.setFontSize(9);
  doc.setTextColor(80, 80, 80);
  doc.setFont('helvetica', 'normal');
  doc.text('Subtotal:', totalsX - 40, totalsY, { align: 'right' });
  doc.text(`Rs. ${bill.subtotal.toFixed(2)}`, totalsX, totalsY, { align: 'right' });

  if (bill.taxPercent > 0) {
    totalsY += 7;
    doc.text(`Tax (${bill.taxPercent}%):`, totalsX - 40, totalsY, { align: 'right' });
    doc.text(`Rs. ${bill.tax.toFixed(2)}`, totalsX, totalsY, { align: 'right' });
  }

  totalsY += 4;
  doc.setDrawColor(201, 168, 76);
  doc.line(totalsX - 80, totalsY, totalsX, totalsY);

  totalsY += 7;
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(12);
  doc.setTextColor(64, 23, 4);
  doc.text('GRAND TOTAL:', totalsX - 40, totalsY, { align: 'right' });
  doc.text(`Rs. ${bill.total.toFixed(2)}`, totalsX, totalsY, { align: 'right' });

  currentY = Math.max(totalsY, currentY + bankHeight);

  if (bill.note) {
    currentY += 10;
    doc.setFont('helvetica', 'italic');
    doc.setFontSize(8);
    doc.setTextColor(120, 120, 120);
    doc.text(`Note: ${bill.note}`, 14, currentY);
  }

  // Footer
  const footerY = doc.internal.pageSize.getHeight() - 20;
  doc.setFillColor(64, 23, 4);
  doc.rect(0, footerY - 4, pageW, 24, 'F');
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(8);
  doc.setTextColor(230, 220, 200);
  doc.text('Thank you for your business! — New Sowtha Smart Billing Software', pageW / 2, footerY + 5, { align: 'center' });

  return doc;
}

export function printBill(bill) {
  const doc = generateBillPDF(bill);
  doc.autoPrint();
  const blob = doc.output('bloburl');
  window.open(blob, '_blank');
}

export function downloadBill(bill) {
  const doc = generateBillPDF(bill);
  doc.save(`${bill.invoiceNo}.pdf`);
}

export function generatePaymentPDF(payment, customer) {
  const doc = new jsPDF();
  const pageW = doc.internal.pageSize.getWidth();

  // Header background - Brand Navy
  doc.setFillColor(64, 23, 4);
  doc.rect(0, 0, pageW, 45, 'F');

  // Add logo image
  doc.addImage(LOGO_BASE64, 'JPEG', 14, 10, 24, 24);

  // Store name (shifted right)
  doc.setFont('times', 'bold');
  doc.setFontSize(22);
  doc.setTextColor(201, 168, 76);
  doc.text('New Sowtha', 42, 20);

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.setTextColor(230, 220, 200);
  doc.text('Payment Transaction Receipt', 42, 27);
  doc.text('Tel: +91 9361713753  |  +91 7639042406', 42, 33);
  doc.text('newsowthaoffice@gmail.com  |  www.newsowtha.com', 42, 39);

  // Receipt details
  doc.setFont('times', 'bold');
  doc.setFontSize(14);
  doc.setTextColor(255, 255, 255);
  doc.text('PAYMENT RECEIPT', pageW - 14, 20, { align: 'right' });
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.setTextColor(230, 220, 200);
  doc.text(`Receipt ID: REC-${payment.id.split('-')[0].toUpperCase()}`, pageW - 14, 28, { align: 'right' });
  doc.text(`Date: ${new Date(payment.date).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}`, pageW - 14, 35, { align: 'right' });
  doc.text(`Mode: ${payment.mode.toUpperCase()}`, pageW - 14, 41, { align: 'right' });

  // Customer section
  doc.setFillColor(253, 246, 227);
  doc.rect(0, 48, pageW, 30, 'F');

  // Col 1: RECEIVED FROM
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(8);
  doc.setTextColor(120, 120, 120);
  doc.text('RECEIVED FROM', 14, 57);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.setTextColor(30, 30, 30);
  doc.text(customer?.name || payment.customerName || 'Customer', 14, 65);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.setTextColor(80, 80, 80);
  if (customer?.phone) doc.text(`Phone: ${customer.phone}`, 14, 72);

  // Col 2: ADDRESS
  const payAddressText = parseAddress(customer?.address);
  if (payAddressText) {
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8);
    doc.setTextColor(120, 120, 120);
    doc.text('ADDRESS', 90, 57);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.setTextColor(80, 80, 80);
    const wrappedAddress = doc.splitTextToSize(payAddressText, 80);
    doc.text(wrappedAddress, 90, 65);
  }

  // Big Highlighted Amount Box
  const boxY = 88;
  doc.setFillColor(253, 246, 227);
  doc.setDrawColor(201, 168, 76);
  doc.setLineWidth(1);
  doc.rect(14, boxY, pageW - 28, 30, 'FD');

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.setTextColor(64, 23, 4);
  doc.text('TRANSACTION STATUS: SUCCESSFUL', pageW / 2, boxY + 8, { align: 'center' });

  doc.setFont('times', 'bold');
  doc.setFontSize(18);
  doc.setTextColor(64, 23, 4);
  doc.text(`AMOUNT PAID: Rs. ${Number(payment.amountPaid).toFixed(2)}`, pageW / 2, boxY + 20, { align: 'center' });

  // Running balance details
  const finalY = boxY + 38;
  doc.setDrawColor(200, 200, 200);
  doc.setLineWidth(0.5);
  doc.line(14, finalY, pageW - 14, finalY);

  // Customer Balance Summary Section
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.setTextColor(64, 23, 4);
  doc.text('CUSTOMER ACCOUNT BALANCE SUMMARY', 14, finalY + 10);

  // Draw a table/grid for Balance Summary
  const summaryRows = [
    ['Total Invoiced Amount (Bills)', `Rs. ${(customer?.totalDue || 0).toFixed(2)}`],
    ['Total Amount Paid to Date', `Rs. ${(customer?.totalPaid || 0).toFixed(2)}`],
    ['Current Outstanding Due Balance', `Rs. ${(customer?.balance || 0).toFixed(2)}`]
  ];

  doc.autoTable({
    startY: finalY + 14,
    body: summaryRows,
    theme: 'plain',
    styles: { fontSize: 10, cellPadding: 4, textColor: [50, 50, 50], valign: 'middle' },
    columnStyles: {
      0: { fontStyle: 'bold', cellWidth: 120 },
      1: { halign: 'right', fontStyle: 'bold', textColor: [64, 23, 4] }
    },
    margin: { left: 14, right: 14 }
  });

  // Footer
  const footerY = doc.internal.pageSize.getHeight() - 20;
  doc.setFillColor(64, 23, 4);
  doc.rect(0, footerY - 4, pageW, 24, 'F');
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(8);
  doc.setTextColor(230, 220, 200);
  doc.text('Thank you for your payment! — New Sowtha Smart Billing Software', pageW / 2, footerY + 5, { align: 'center' });

  return doc;
}

export function printPayment(payment, customer) {
  const doc = generatePaymentPDF(payment, customer);
  doc.autoPrint();
  const blob = doc.output('bloburl');
  window.open(blob, '_blank');
}

export function downloadPayment(payment, customer) {
  const doc = generatePaymentPDF(payment, customer);
  const receiptName = `Receipt_${(payment.customerName || 'Customer').replace(/\s+/g, '_')}_${payment.date}`;
  doc.save(`${receiptName}.pdf`);
}
